<ng-container *ngIf="showUpsell">
  <ng-container *ngTemplateOutlet="upsellBody"></ng-container>
</ng-container>

<ng-container *ngIf="isFlightBySector">
  <ng-container *ngTemplateOutlet="fareBody"></ng-container>
</ng-container>

<ng-template #upsellBody>
  <ng-container *ngIf="bannerUpsellSelectedMobile; else upsellnotSelected">
    <div class="container-upsell-selected">
      <span class="rate-upsell">{{ 'BOOKING_MODULE.FARE' | transloco: { fareType: cleanFareFamilyNames| capitalize } }}</span>
      <div class="open-upsell" (click)="openUpsell.emit()">
        <span class="modify">{{'BOOKING_MODULE.EDIT' | transloco}}</span>
        <ng-container *ngIf="upsellLoading; else buttonSeeRates">
          <div class="loader">
            <app-btn-loader [btnSize]="loaderSize" [classColor]="loaderColor"></app-btn-loader>
          </div>
        </ng-container>
      </div>
    </div>
  </ng-container>
</ng-template>

<ng-template #fareBody>
  <div class="container-upsell-selected" *ngIf="!!fareFamilies">
    <span class="rate-upsell">{{'FLIGHT_RESULTS_MODULE.ITINERARY_LIST_SECTION.FARE' | transloco: { fareType: cleanFareFamilyNames | capitalizeAll } }}</span>
  </div>
</ng-template>

<ng-template #upsellnotSelected>
  <div class="container-upsell-banner" [class.no-shadow]="noShadow" [class.no-radius-bottom]="bannerUpsellSelectedDesktop">
    <div class="content-text">
      <span [innerHTML]="'BOOKING_MODULE.'+ baggageImproveMessage | transloco"></span>
      <div class="view-options" (click)="openUpsell.emit()">
        <span>{{'BOOKING_MODULE.IMPROVE_YOUR_FLIGHT_VIEW_OPTIONS' | transloco}}</span>
        <ng-container *ngIf="upsellLoading; else buttonSeeRates">
          <div class="loader">
            <app-btn-loader [btnSize]="loaderSize" [classColor]="loaderColor"></app-btn-loader>
          </div>
        </ng-container>
      </div>
    </div>
    <div class="content-images">
      <img class="logo" height="75" loading="lazy" [src]="agentTravelImage | ImageCdn">
    </div>
  </div>
  <div class="container-upsell-selected-desktop" *ngIf="bannerUpsellSelectedDesktop">
    <span class="rate-upsell">{{ 'BOOKING_MODULE.FARE' | transloco: { fareType: cleanFareFamilyNames| capitalize } }}</span>
  </div>
</ng-template>

<ng-template #buttonSeeRates>
  <i aria-hidden="true" class="icon-expand"></i>
</ng-template>